import { render, staticRenderFns } from "./ToolbarAttributes.vue?vue&type=template&id=65a6829e&scoped=true"
import script from "./ToolbarAttributes.vue?vue&type=script&lang=js"
export * from "./ToolbarAttributes.vue?vue&type=script&lang=js"
import style0 from "./ToolbarAttributes.vue?vue&type=style&index=0&id=65a6829e&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65a6829e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('65a6829e')) {
      api.createRecord('65a6829e', component.options)
    } else {
      api.reload('65a6829e', component.options)
    }
    module.hot.accept("./ToolbarAttributes.vue?vue&type=template&id=65a6829e&scoped=true", function () {
      api.rerender('65a6829e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/toolbar/ToolbarAttributes.vue"
export default component.exports